import { render } from "./EditQuestion.vue?vue&type=template&id=7ddc4138"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__